import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import moment from "moment";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils";

export const productPricingFilterTodo = createAsyncThunk('productPricingFilter', async ({ pageable: data, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + 'product-pricings-with-filters',
            params: {
                'subCategoryId': data?.sub_cat_id,
                'brandId': data?.brand_id,
                'wefDate': data?.date && moment(data?.date).format("YYYY-MM-DD"),
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const productPricingFilterSlice = createSlice({
    name: 'productPricingFilter',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(productPricingFilterTodo.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }

        });
        builder.addCase(productPricingFilterTodo.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default productPricingFilterSlice.reducer; 